<template>
    <div>
        <el-button @click="openDialog" title="查看详情" size="mini" :class="config.btnIcon">{{config.btnName}}</el-button>
        <el-dialog @opened="opened" :ref="{'win_':parentId}" title="查看详情" @closed="dialogClose" :modal-append-to-body="false" destroy-on-close fullscreen  :visible.sync="dialogShow">
            <pm-form-render style="margin-top: -20px;"
                            ref="custmRef"
                            :toChild="true"
            ></pm-form-render>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "dialogOpenBtnItem",
    props: {
        parentId: {
            type: String,
            required: true
        },
        paramMap: {
            type: Object,
            required: true
        },
        context:{
            type: Object,
            default: function (){
                return {}
            }
        },
        config:{
            type: Object,
            required: true,
            default:function (){
                return {formId:'',btnName:"查看",btnIcon:"el-icon-view"}
            },
        }
    },
    data(){
        return {
            filterMap:{},
            formInfo:{},
            groupList:{},
            formId:this.config.formId,
            dialogShow:false,
            categoryCode:"",
        }
    },
    created() {
        this.filterMap={...this.paramMap}
        this.filterMap["entityId"]=this.parentId
    },
    methods:{
        dialogClose(){
            this.dialogShow=false;
        },
        opened(){
            this.$nextTick(()=>{
                this.filterMap=Object.assign(this.filterMap,this.context);
                this.$refs.custmRef.getCustomData && this.$refs.custmRef.getCustomData(this.formId,this.filterMap);
            })
        },
        openDialog(){
            this.dialogShow=true;
        }
    }
}
</script>

<style scoped>
</style>